import { Snackbar, Box, Typography } from "@mui/material";
import { Check } from "@mui/icons-material";
import { FilterSuccessProps } from "../api/types";


const FilterSuccess = ({ open, displayLabel }: FilterSuccessProps) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={2500}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{
        mt: 16,
        mr: 4,
      }}
    >
      <Box
        sx={{
          px: 2.5,
          py: 1.5,
          borderRadius: 2,
          backgroundColor: "#22c55e",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          boxShadow: "0px 20px 50px rgba(34, 197, 94, 0.35)",
        }}
      >
        <Box
          sx={{
            width: 30,
            height: 30,
            borderRadius: "50%",
            backgroundColor: "#18eb65ff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Check sx={{ fontSize: 14, color: "#fff" }} />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Typography fontWeight={600} fontSize={14}>
            Filter Applied!
          </Typography>

          <Typography fontSize={12} sx={{ opacity: 0.9 }}>
            Now showing: {displayLabel}
          </Typography>
        </Box>
      </Box>
    </Snackbar>
  );
};

export default FilterSuccess;
